import { Component, OnInit, OnDestroy, Input, ViewChild, ViewContainerRef, ComponentRef, ComponentFactory, ComponentFactoryResolver } from '@angular/core';
import { CompoundCheckmarkComponent } from './compound.checkmark.component';

@Component({
  selector: 'checkmark-with-items',
  templateUrl: './checkmark.with.items.component.html'
})
export class CheckmarkWithItemsComponent implements OnInit, OnDestroy {
  @ViewChild("checkmarkContainer", { read: ViewContainerRef }) checkmarkContainer: ViewContainerRef;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() jsclassinit:any;
  @Input() questioninitmixin:any;
  @Input() value:any;
  @Input() disabled:boolean;
  @Input() required:boolean;

  children:ComponentRef<any>[];

  constructor(
    private resolver: ComponentFactoryResolver
  ){
    this.children = [];
  }

  public getValue():object {
    var result={},children={},candidate;
    if(!this.disabled) {
      for(let i in this.children){
        candidate=this.children[i].instance.getValue();
        if(!!candidate) {
          Object.assign(children,candidate);
        }
      }
      result[this.questionid]=children;
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  isValid():boolean {
    var result=true;
    this.children.forEach((item)=>{
      result=item.instance.isValid() && result;
    });
    return result;
  }
  validate():boolean {
    var result=true;
    this.children.forEach((item)=>{
      result=item.instance.validate() && result;
    });
    return result;
  }

  ngOnInit() {
    var factory:ComponentFactory<any>;
    var i;
    this.jsclassinit=Object.assign({},this.jsclassinit,this.questioninitmixin);

    factory=this.resolver.resolveComponentFactory(CompoundCheckmarkComponent);
    if('items' in this.jsclassinit) {
      this.jsclassinit['items'].forEach((item)=>{
        this.children[item]=this.checkmarkContainer.createComponent(factory);
        this.children[item].instance['label']=item;
      });
    }
    for(i in this.value){
      if(i in this.children) {
        this.children[i].instance['items']=this.value[i];
      }
    }
  }

  ngOnDestroy() {
    var i,C;
    for(i in this.children) {
      this.children[i].destroy();
      delete this.children[i];
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/checkmark.with.items.component.ts